'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../i-bem/i-bem.react');

var _eHiddenLinks = (require('./__hidden-links/tableau-node__hidden-links.react.js').default || require('./__hidden-links/tableau-node__hidden-links.react.js')).applyDecls();

var _eHiddenLinks2 = _interopRequireDefault(_eHiddenLinks);

var _eLinks = (require('./__links/tableau-node__links.react.js').default || require('./__links/tableau-node__links.react.js')).applyDecls();

var _eLinks2 = _interopRequireDefault(_eLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'tableau-node'
}, {
    HiddenLinks: _eHiddenLinks2.default,
    Links: _eLinks2.default
});